<template>
  <v-dialog
    v-model="visible"
    @keydown.esc="close"
    persistent
    scrollable
    max-width="600"
    style="z-index: 6"
  >
    <v-form ref="addPrinterForm" @submit.prevent="submit">
      <v-card
        flat
        class="overflow-auto"
        :class="{ 'mobile-card': $vuetify.breakpoint.smAndDown }"
      >
        <div class="modal-header">
          <v-icon color="#00BCD4" size="20" class="mr-2">mdi-file-tree</v-icon>
          <span class="modal-title">Ustrojstvena jedinica</span>
          <v-spacer></v-spacer>
          <span class="modal-close-btn" @click="close">
            <v-icon size="20">mdi-close</v-icon>
          </span>
        </div>
        <v-card-text>
          <v-row class="flex-wrap justify-center">
            <v-col>
              <v-row>
                <v-col>
                  <v-text-field
                    dense
                    outlined
                    label="Naziv jedinice"
                    autofocus
                    v-model="name"
                    class="pt-2 form-input"
                    :rules="[rules.req]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7" class="pb-0">
                  <v-select
                    outlined
                    dense
                    label="Odaberite printer"
                    :items="sortedPrinters"
                    item-text="name"
                    item-value="id"
                    v-model="selectedPrinter"
                    class="form-input"
                  ></v-select>
                </v-col>
                <v-col cols="5">
                  <v-btn
                    x-small
                    class="mt-2"
                    style="z-index: 4"
                    bottom
                    right
                    plain
                    text
                    @click="openAddPrinter"
                  >
                    <v-icon>mdi-plus</v-icon>
                    <span>Dodaj printer</span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="7" class="pb-0">
                  <v-select
                    multiple
                    outlined
                    dense
                    label="Odaberite kategorije artikala"
                    :items="sortedCategories"
                    return-object
                    item-text="name"
                    v-model="selectedCategories"
                    :rules="[rules.arrReq]"
                    class="form-input"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pb-5">
          <v-btn
            text
            class="btn-primary"
            height="45"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            Dodaj jedinicu
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <add-printer-inline ref="addPrinter"></add-printer-inline>
    <v-overlay v-show="loading" absolute z-index="10">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>
<script>
import { df, functions } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import rules from '@/plugins/rules'
import AddPrinterInline from '@/modules/point-of-sale/components/printer-configuration/AddPrinterInline'
import { clone } from '@/plugins/utils'

export default {
  components: { AddPrinterInline },
  inject: ['showMsgBox', 'showLoader', 'hideLoader'],
  props: {
    location: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    visible: false,
    submitting: false,
    name: undefined,
    selectedPrinter: undefined,
    printers: [],
    sortedPrinters: [],
    selectedCategories: [],
    categories: [],
    sortedCategories: [],
    loading: false,
    rules: {
      req: rules.req(),
      arrReq: rules.arrReq(),
      eq: rules.eq
    },
    listeners: []
  }),
  mounted () {
    this.open(this.location.id)
  },
  methods: {
    openAddPrinter () {
      this.$refs.addPrinter.open(this.location.id)
    },
    open (locationId) {
      const query = df
        .collection(`location_printers/${this.location.id}/printers`)
      const listener = query
        .onSnapshot((doc) => {
          doc.docs.forEach((rec) => {
            this.printers.push(rec.data())
          })
          this.sortedPrinters = clone(this.printers.sort((a, b) => a.name.localeCompare(b.name)))
        }
        )
      this.listeners.push(listener)

      this.listeners.push(
        df
          .doc(`company_categories/${this.company.id}`)
          .onSnapshot((doc) => {
            if (
              doc &&
              doc.data() &&
              doc.data().categories &&
              Object.keys(doc.data().categories).length > 0
            ) {
              this.categories = Object.keys(doc.data().categories).map(
                (key) => {
                  return doc.data().categories[key]
                }
              )
            }
            this.sortedCategories = clone(this.categories.sort((a, b) => a.name.localeCompare(b.name)))
          })
      )
      this.visible = true
      this.submitting = false
      this.locationId = locationId
    },
    close () {
      this.resetInputs()
      this.$emit('close')
    },
    resetInputs () {
      this.name = undefined
      this.printer = undefined
      this.visible = false
      this.selectedCategories = []
    },
    async submit () {
      this.loading = true
      const tblId = uuidv4()
      const docRef = df.doc(`location_units/${this.locationId}/units/${tblId}`)

      const categories = this.selectedCategories.map((category) => {
        return {
          id: category.id,
          name: category.name,
          picture: category.picture
        }
      })

      if (categories && categories.length > 0) {
        const payload = {
          action: {
            operation: 'set',
            entity: 'organizational_unit',
            params: {
              organizational_unit_id: tblId,
              company_id: this.company.id,
              location_id: this.location.id,
              categories: categories
            }
          }
        }

        try {
          var companyitemApi = functions.httpsCallable('companyitemapi')

          companyitemApi({
            action: {
              operation: payload.action.operation,
              entity: payload.action.entity,
              resource_id: payload.action.resource_id,
              params: payload.action.params
            }
          })
            .then((result) => {

            })
        } catch (err) {
          this.showMsgBox({
            text: err && err !== '' ? err : 'An error has occurred',
            actions: ['cancel'],
            cancelBtnText: this.$t('$vuetify.close'),
            color: 'error'
          })
        }
      }

      try {
        await docRef.set(
          {
            id: tblId,
            name: this.name,
            printer: this.selectedPrinter && this.selectedPrinter !== '' ? this.selectedPrinter : ''
          }
        )
        console.log('Table successfully saved.')
      } catch (err) {
        console.error('Error saving table: ', err)
      }
      this.loading = false
      this.resetInputs()
      this.$emit('close')
    }
  }

}
</script>
<style scoped>
.modal-header {
  display: flex; align-items: center;
  padding: 22px 24px 16px;
  border-bottom: 1px solid #F1F5F9;
}
.modal-title { font-size: 16px; font-weight: 700; color: #1e293b; }
.modal-close-btn {
  display: inline-flex; align-items: center; justify-content: center;
  width: 28px; height: 28px;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;
}
.modal-close-btn:hover { background: #FEE2E2; color: #DC2626; }
.form-input >>> .v-input__slot {
  border-radius: 8px !important;
  background: #F8FAFC !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}
.btn-secondary {
  padding: 11px 20px;
  background: #F8FAFC;
  border: 1.5px solid #E2E8F0;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-secondary:hover {
  background: #F1F5F9;
  border-color: #CBD5E1;
  color: #334155;
}
</style>
